const TIMER = {
  POPUP: 3000,
  LOADING: 3000,
};

export default TIMER;
